import { render, staticRenderFns } from "./AsignarPermiso.vue?vue&type=template&id=257166c7&"
import script from "./AsignarPermiso.vue?vue&type=script&lang=js&"
export * from "./AsignarPermiso.vue?vue&type=script&lang=js&"
import style0 from "./AsignarPermiso.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports